import React from 'react'
import PropTypes from 'prop-types'

import { Dots, Heading } from 'Components/Blocks/_Legacy'
import { Border, Image, Motion, Text, Wrapper } from 'Components/UI'

import { cpuGlyph } from 'Assets/_Legacy/BlockchainPage/icons'

import { TECHNOLOGIES } from './mock'
import {
  Card,
  CardsWrapper,
  Container,
  Content,
  DotsWrapper,
  LogoHolder,
  TextHolder,
} from './styles'

function Technology({ data }) {
  return (
    <>
      <Border bg="primary" big topRight />

      <Container>
        <Wrapper wayPointTop>
          <Content>
            <Motion>
              <Heading
                mb={[56, 56, 64, 64, 88]}
                subTitleText={data?.subtitleText}
                tagGlyph={cpuGlyph}
                tagText={data?.overheadText}
                tagTextAs="h4"
                titleText={{
                  first: {
                    text: data?.titleTextFirst,
                    bold: data?.firstBold,
                  },
                  second: {
                    text: data?.titleTextSecond,
                    bold: data?.secondBold,
                  },
                }}
              />

              <CardsWrapper>
                {TECHNOLOGIES.map(item => (
                  <Card key={item.id}>
                    <LogoHolder mr={[24, 24, 32]}>
                      <Image alt="" image={item.logo} layout="intrinsic" lazy />
                    </LogoHolder>

                    <TextHolder>
                      <Text as="h3" bold fontSize={[16, 16, 20]} mb={2}>
                        {item.name}
                      </Text>

                      <Text fontSize={[14, 14, 16]} light>
                        {item.text}
                      </Text>
                    </TextHolder>
                  </Card>
                ))}

                <DotsWrapper>
                  <Dots columns={17} primary rows={8} />
                </DotsWrapper>
              </CardsWrapper>
            </Motion>
          </Content>
        </Wrapper>
      </Container>
    </>
  )
}

Technology.defaultProps = {
  data: {},
}

Technology.propTypes = {
  data: PropTypes.object,
}

export default Technology
